// extracted by mini-css-extract-plugin
export default {"divider":"divider__l7yCf","character":"character__atbwd","active":"active__DI5ru","character-name":"character-name__aOTHW","characterName":"character-name__aOTHW"};